import React, {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import { formatTimeAgo, toFullWidthNumber} from "utils/format";
import CustomPagination from "components/CustomPagination";
import {useDispatch, useSelector} from "react-redux";
import {
  getListNews, setCanBackPrevPage, setNewsCardBookmark,
  setError, setSuccess
} from "reducers/talentHome";
import {ThunkDispatch} from "@reduxjs/toolkit";
import CustomIconButton from "../../../components/CustomIconButton";
import CustomToast from "../../../components/CustomToast";
import { useSnackbar } from "notistack";
import NewsCard from "./NewsCard";

interface NewsItemProps {
  news: any;
}
const NewsItem: React.FC<NewsItemProps> = ({ news }) => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const navigate = useNavigate();
  const [mark, setMark] = useState(false);

  const goDetail = (id: any) => {
    dispatch(setCanBackPrevPage(true));
    navigate("/talent/news/" + id)
  }

  const handleBookmark = (id) => {
    dispatch(setNewsCardBookmark({id: id, view: "news", requestBody: {}}));
  }

  return (
    <div className="h-full rounded-lg md:rounded-2xl rounded-b-none md:rounded-b-none bg-white group pb-4 border-b border-b-[#E0E0E0] flex flex-col">
      <NewsCard items={news} goToDetail={(id) => goDetail(id)} handleBookmark={(id) => handleBookmark(id)} />
    </div>
  );
};

const NewsList = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const [currentPage, setCurrentPage] = useState(1);
  const { pageSize, news, totalNews, error, success, actionName, isReloadNews } = useSelector((state: any) => state.talentHome);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const handleChangePage = (page: number) => {
    setCurrentPage(page)
    const data = { page: page, pageSize: pageSize };
    dispatch(getListNews(data));
  };

  useEffect(() => {
    // Get list news
    const data = { page: currentPage, pageSize: pageSize };
    dispatch(getListNews(data));
  }, [isReloadNews]);

  const showToast = (title: string, message: string, variant: string, textLink: string = "", clickOnText: any = "") => {
    enqueueSnackbar("I love snacks.", {
      content: (key) => (
        <CustomToast title={title} message={message} variant={variant} textLink={textLink} clickOnText={clickOnText} snackbarKey={key} closeSnackbar={closeSnackbar} />
      ),
    });
  };

  useEffect(() => {
    if(actionName == "setNewsCardBookmark"){
      if(success){
        showToast('メッセージ', success, "success");
        dispatch(setSuccess(null));
      }
      else if(error){
        showToast('メッセージ', error, "error");
        dispatch(setError(null));
      }
    }
  }, [error, success]);

  return (
    <>
      <div className="bg-white p-6 flex flex-wrap gap-x-4 gap-y-6 mb-4 rounded-2xl alu-section-box-shadow">
        {news.map((item: any, idx: any) => (
          <div key={idx} className="w-[calc(33.333%-10.67px)]">
            <NewsItem news={item} />
          </div>
        ))}
      </div>

      {totalNews > pageSize && (
        <div className="flex items-center justify-center">
          <CustomPagination
            total={totalNews}
            currentPage={currentPage}
            pageSize={pageSize}
            onPageChange={handleChangePage}
          />
        </div>
        )}
    </>
  );
};

export default NewsList;
